

































import { Component, Vue, Prop } from "vue-property-decorator";
import { ContrastColor } from "@/data/enums/ui";
import { ClientTemplateSlotCodes } from "@/data/enums/templates";
import { IState } from "@/store";

@Component({
  components: {
    "powered-by-upmind": () => import("@/skeleton/poweredByUpmind.vue"),
    "brand-language-selector": () =>
      import("@/components/app/global/brand/brandLanguageSelector.vue"),
    "client-template-render-provider": () =>
      import(
        `@/components/app/global/templates/clientTemplateRenderProvider.vue`
      )
  }
})
export default class ClientFooter extends Vue {
  // Data
  @Prop({ default: null })
  public contrastColor!: ContrastColor | null;
  // Computed
  public get clientTemplateProps() {
    return {
      code: ClientTemplateSlotCodes.FOOTER,
      objectId: (this.$store.state as IState).brand?.id,
      withAccessToken: false
    };
  }

  public get showLangSelector() {
    if (this.$store.getters.isAdminContext)
      return !this.$store.getters[`auth/admin/isAuthenticated`];
    return !this.$store.getters[`auth/client/isAuthenticated`];
  }
}
